// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"cb1fb645","221":"92172f73","357":"2c066e4a","453":"eb9b73df","576":"e69de6e0","615":"ff6528de","722":"bfe9457a","752":"7c76c9b9","832":"67c8e907","855":"784fe63b","858":"d5051265","918":"a0a461a3","942":"cd47d9b9"}[chunkId] + ".chunk.js";
};